<template>
  <div class="pb-4 mb-4 border-b border-grey-200 gd-changelog">
    <span
      v-for="(label, idx) in labels"
      :key="idx"
      :class="`inline-block px-2 py-1 mr-2 mb-2 font-semibold text-xs rounded`"
      :style="`background-color: ${
        labelColorMap[label] ? labelColorMap[label].bg : '#f2f2f2'
      }; color: ${
        labelColorMap[label] ? labelColorMap[label].text : '#747474'
      }`"
      >{{ label }}</span
    >
    <div class="flex justify-between">
      <p
        class="flex-auto font-semibold text-grey-700 text-sm tracking-wide w-4/6"
      >
        {{ title }}
      </p>
      <span
        class="flex-1 font-semibold text-grey-600 text-right text-xs"
        v-if="timestamp"
        >{{ timestamp }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    labels: {
      type: Array,
      required: true,
    },
    timestamp: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      labelColorMap: {
        GroovePages: { bg: '#e5f0ff', text: '#3677f6' },
        GrooveWebinar: { bg: '#fef3ea', text: '#df9b5c' },
        GrooveSell: { bg: '#ddf4e8', text: '#6baf8b' },
        GrooveKart: { bg: '#ddf4e8', text: '#6baf8b' },
        GrooveMail: { bg: '#ffe7e3', text: '#e95843' },
        Bug: { bg: '#ffeee2', text: '#e5792b' },
        Improvement: { bg: '#38dfbf', text: '#ffffff' },
        Feature: { bg: '#b99ef4', text: '#5929c1' },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.gd-changelog:last-of-type {
  border-bottom: 0px;
  margin-bottom: 0px;
}
</style>